import Divider from "./Divider";

export default function FooterGroup({
  title,
  containerClassName = "",
  contentClassName = "",
  children,
}) {
  return (
    <div
      className={`md:w-1/4 flex flex-col items-center md:items-start gap-[16px] ${containerClassName}`}
    >
      <p className="font-bold text-[18px] leading-[26px] text-[#404040]">
        {title}
      </p>
      <Divider />
      <div
        className={`text-center md:text-left ${contentClassName}`}
      >
        {children}
      </div>
    </div>
  );
}
